'use client'

import { useEffect, useRef } from 'react'
import { trackActivity, trackDwellTime } from '~/lib/activity-tracking'

type Props = {
  activityType: 'EVENT_VIEW' | 'PROFILE_VIEW'
  targetType: 'EVENT' | 'FACILITATOR' | 'MEMBER'
  targetId: string
  accessToken?: string
}

export function ActivityViewTracker({ activityType, targetType, targetId, accessToken }: Props) {
  const startTimeRef = useRef<number>(0)
  const dwellSentRef = useRef(false)

  useEffect(() => {
    // Fire the view event immediately
    trackActivity(activityType, targetType, targetId, { accessToken })
    startTimeRef.current = Date.now()
    dwellSentRef.current = false

    const sendDwell = () => {
      if (dwellSentRef.current) return
      dwellSentRef.current = true
      const dwellMs = Date.now() - startTimeRef.current
      trackDwellTime(activityType, targetType, targetId, dwellMs, accessToken)
    }

    // Send dwell time when tab becomes hidden (covers mobile tab switch, app switch)
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        sendDwell()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    // Cleanup: send dwell time on component unmount (in-app navigation)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      sendDwell()
    }
  }, [activityType, targetType, targetId, accessToken])

  return null
}
